import React from 'react';
import { arrayOf, bool, instanceOf, number, oneOfType, string } from 'prop-types';
import { Typography } from '@mui/material';
import { I18n } from 'utils/i18n';
import userShape from 'shapes/user';
import acknowledgesShape from 'shapes/acknowledge';
import moment from 'moment';
import connector from './connector';

const AcknowledgeCation = ({
  acknowledges,
  authUser = null,
  digitalSignature = false,
  form,
  declinedAt = null,
}) => {
  if (declinedAt) {
    return (
      <Typography align="center" variant="caption" sx={{ mt: 1.25 }}>
        {`${I18n.t('AcknowledgementMessage.Declined on')} ${moment(declinedAt).format('LL')}`}
      </Typography>
    );
  }
  const acknowledge = acknowledges && acknowledges.find(m => m.user === authUser?._id);
  if (!acknowledge) return null;

  const date = moment.unix(acknowledge.confirmedAt).format('LL');

  let message = '';
  if (acknowledge && digitalSignature) {
    message = `${I18n.t('AcknowledgementMessage.Digital signature made on')} ${date}`;
  } else if (form) {
    message = `${I18n.t('AcknowledgementMessage.Form sent on')} ${date}`;
  } else if (acknowledge) {
    message = `${I18n.t('AcknowledgementMessage.Acknowledge made on')} ${date}`;
  }
  return (
    <Typography align="center" variant="caption" sx={{ mt: 1.25 }}>
      {message}
    </Typography>
  );
};

AcknowledgeCation.propTypes = {
  acknowledges: arrayOf(acknowledgesShape).isRequired,
  authUser: userShape,
  digitalSignature: bool,
  declinedAt: oneOfType([string, number, instanceOf(Date)]),
};

export default connector(AcknowledgeCation);
